import { Formik, Form } from "formik";
import React from "react";
import { Col, Row } from "react-bootstrap";
import * as yup from "yup";
import { validate as luhnValidate } from "luhn";
import { RegistrationSteps } from "../Registration";
import StepContainer from "./StepContainer";
import Address from "../../Core/Customer/Address";
import Communication from "../../Core/Customer/Communication";
import Details from "../../Core/Customer/Details";
import IDNumberInput from "../../Core/IDNumberInput";
import SalesAgentSelect from "../../Core/Customer/SalesAgentSelect";
import GradientButton from "../../Core/GradientButton";

export default function CustomerDetails(props) {
	const initialValues = props.customer ?? {
		FirstName: "",
		Surname: "",
		Email: "",
		CellphoneNumber: "",
		LanguagePreference: null,
		EmailPreference: null,
		IDNumber: "",
		IDNumberPreference: "ID",
		SalesAgentId: props.address?.SalesAgentId ?? null,
		PotentialAddress: "",
	};

	const validationSchema = yup
		.object({
			FirstName: yup
				.string()
				.required("First Name is required.")
				.matches(/^[a-zA-Z\s]*$/, "First Name can only contain letters and spaces."),
			Surname: yup
				.string()
				.required("Surname is required.")
				.matches(/^[a-zA-Z\s]*$/, "Surname can only contain letters and spaces."),
			Email: yup.string().email("Invalid Email Format"),
			PotentialAddress: props.address
				? yup.string()
				: yup
						.string()
						.required("Address is required.")
						.matches(/^[a-zA-Z0-9\s.,]*$/, "Address can only contain letters, numbers, spaces, periods, and commas."),
			CellphoneNumber: yup
				.string()
				.required("Cellphone Number is required.")
				.test("phone-format", "Phone number is not valid.", function (value) {
					if (!value) return false;
					if (value.startsWith("0")) return /^0\d{9}$/.test(value);
					return /^\d{9}$/.test(value);
				}),
			IDNumber: yup.string().when("IDNumberPreference", {
				is: "ID",
				then: yup
					.string()
					.required("ID Number is required")
					.min(13, "Must contain 13 characters")
					.matches(/^\d+$/, "Invalid ID Number")
					.test({ message: "Invalid ID Number", test: (value) => luhnValidate(value) }),
				otherwise: yup.string().required("Passport Number is required"),
			}),
		})
		.required();

	function handleSubmit(values) {
		props.onContinue(values, RegistrationSteps.CustomerDetails.Step);
	}

	return (
		<StepContainer title="Please enter the following customer information in order to setup your account:">
			<Row>
				<Col>
					<Formik
						initialValues={initialValues}
						validationSchema={validationSchema}
						onSubmit={handleSubmit}
						enableReinitialize
					>
						{({ errors, touched }) => (
							<Form>
								<Details touched={touched} errors={errors} />
								<Address address={props.address} touched={touched} errors={errors} />
								<Communication touched={touched} errors={errors} />
								<IDNumberInput preferenceField={"IDNumberPreference"} idField={"IDNumber"} />
								<Row className="align-items-center mt-4">
									<SalesAgentSelect existingCustomer={props.address?.ExistingCustomer} />
									<Col xs={12} lg={6} className="offset-xs-0 offset-lg-2 mt-3 mt-lg-0">
										<GradientButton title="Submit" variant="greenYellow" type="submit" />
									</Col>
								</Row>
							</Form>
						)}
					</Formik>
				</Col>
			</Row>
		</StepContainer>
	);
}
